import { render } from "./tournament-player-data.vue?vue&type=template&id=d02e04c6&ts=true"
import script from "./tournament-player-data.vue?vue&type=script&lang=ts"
export * from "./tournament-player-data.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Reports/tournament-player-data.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d02e04c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d02e04c6', __exports__)) {
    api.reload('d02e04c6', __exports__)
  }
  
  module.hot.accept("./tournament-player-data.vue?vue&type=template&id=d02e04c6&ts=true", () => {
    api.rerender('d02e04c6', render)
  })

}


export default __exports__